<template lang="pug">
//- v-loading="section.loading"
section.grid(:style="style" :class="{ [`outline-${gridOutline}`]: !section.loading }")
    //- v-for="area in config.areas"
    .spinner-container(v-if="section.loading")
        .spinner
    //- :area-grid-options="areaGridOptions"
    Area(
        v-for="(area, index) in section.gridAreas"
        :key="area.key"
        :nth="index + 1"
        :class="{ [`outline-${areaOutline.type}`]: !section.loading && area.id == areaOutline.id }"
        :config="area"
        :root-area-config="rootAreaConfig"
        :sections-address="[...sectionsAddress, 'gridAreas', index, 'gridItems']"
        :area-section-options="areaSectionOptions"
        :area-grid-options="[]"
        :active-grid-config="activeGridConfig"
        :grid-section="section"
        :sortable="sortable"
        :deletable="section.gridAreas.length > 1"

        :trigger-update-grid-positions="triggerUpdateGridPositions"

        :dragging="dragging"
        @dragging="value => $emit('dragging', value)"

        @edit:grid="data => $emit('edit:grid', data)"
        @delete:grid="$emit('delete:grid', section)"

        @add:area="data => $emit('add:area', { area, ...data })"
        @edit:area="data => $emit('edit:area', { area, ...data })"
        @delete:area="$emit('delete:area', area)"

        @highlight:grid="type => gridOutline = type"
        @unhighlight:grid="gridOutline = 'none'"
        @highlight:area="type => areaOutline = { type, id: area.id }"
        @unhighlight:area="areaOutline = { type: 'none', id: undefined }"
    )

    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit grid')"
        :visible.sync="scopedUI.form"
        :close-on-press-escape="true"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="resetDrawer"
    )
        .drawer-body(v-loading="drawer.loading")
            el-tabs(
                v-if="!drawer.loading"
                v-model="drawer.tab"
                tab-position="top"
            )
                el-tab-pane(name="grid" :label="$t('Grid')")
                    .tab-content
                        grid-preview(
                            type="edit"
                            :rows="section.rows"
                            :columns="section.columns"
                            :active-breakpoint="activeBreakpoint"
                            :areas="section.gridAreas"
                        )
                        .under-construction
                            i.el-icon-fa-snowplow.fas
                            h4 {{ $t('Under Construction') }}
                            p {{ $t('Come back another time') }}
                            el-tab-pane(name="settings" :label="$t('Settings')")
                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include /components/Page/Sections/settings.pug
        .drawer-footer
            include /components/Page/Sections/section-drawer-footer.pug
</template>

<script>
import { getActiveGridConfig } from '@/helpers'

import Area from '@/components/Page/Area'
import Section from '@/components/Page/Sections/Section'
import GridPreview from '@/components/Page/Grid/Preview'
import { useSetupStore } from '@/stores'

export default {
    name: 'Grid',
    extends: Section,
    props: {
        dragging: {
            type: Boolean,
            default: false
        },
        sectionsAddress: {
            type: Array,
            required: true,
        },
        areaSectionOptions: {
            type: Array,
            required: true,
        },
        areaGridOptions: {
            type: Array,
            required: true,
        },
        // i: {
        //     type: Number
        // },
        rootAreaConfig: {
            type: Object,
            required: false,
        },

        triggerUpdateGridPositions: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Area,
        GridPreview,
    },
    data: () => ({
        gridOutline: 'none',
        areaOutline: {
            type: 'none',
            id: undefined,
        },
        drawer: {
            loading: false,
            saving: false,
            tab: 'settings',
            tabs: ['grid', 'settings'],
            section: undefined,
        }
    }),
    computed: {
        editable() {
            return true
        },
        breakpoints() {
            return _.get(this.activeCms, 'config.template.breakpoints') || []
        },
        activeGridConfig() {
            let config = {
                id: this.section.id,
                key: this.section.key,
                name: this.section.name,
                type: this.sectionConfig.type,
                areas: this.sectionConfig.areas,
                rows: [],
                columns: [],
            }

            // get current breakpoint (manually selectable)
            // get corresponding style config
            if (this.breakpoints.length && this.activeBreakpoint) {
                const indexes = _.cloneDeep(this.breakpoints).sort((a, b) => a.value - b.value).map((el, i) => el.key)
                config.rows = getActiveGridConfig(indexes, this.section.rows, this.activeBreakpoint.key)
                config.columns = getActiveGridConfig(indexes, this.section.columns, this.activeBreakpoint.key)
            }

            return config
        },
        style() {
            // let rows, columns

            // const getStyle = (indexes, type = 'rows') => {
            //     let result
            //     if (this.sectionConfig[type] && _.isArray(this.sectionConfig[type])) {
            //         _.cloneDeep(this.sectionConfig[type]).sort((a, b) => indexes.indexOf(b.key) - indexes.indexOf(a.key)).forEach(row => {
            //             if (result || indexes.indexOf(row.key) < 0 || indexes.indexOf(this.activeBreakpoint.key) < indexes.indexOf(row.key)) return
            //             if (_.isString(row.value)) {
            //                 // const regex = new RegExp(/[^\s()]+(?:\([^\s()]+(?:\([^()]+\))?(?:, *[^\s()]+(?:\([^()]+\))?)*\))?/, 'g')
            //                 // const matches = row.value.matchAll(regex)
            //                 // for (const match of matches) {
            //                 //     console.log('>>>', match);
            //                 // }
            //                 result = row.value
            //             } else if (_.isArray(row.value)) {
            //                 result = row.value.join(' ')
            //             }
            //         })
            //     } else {
            //         result = this.sectionConfig[type]
            //     }
            //     return result
            // }

            // // get current breakpoint (manually selectable)
            // // get corresponding style config
            // if (this.breakpoints.length && this.activeBreakpoint) {
            //     const indexes = _.cloneDeep(this.breakpoints).sort((a, b) => a.value - b.value).map((el, i) => el.key)
            //     rows = getStyle(indexes, 'rows')
            //     columns = getStyle(indexes, 'columns')
            // }

            return {
                'grid-template-rows': this.activeGridConfig.rows.join(' '),
                // 'grid-template-columns': this.activeGridConfig.columns.join(' '),
                'grid-template-columns': this.activeGridConfig.columns.map(col => {
                    if (col.trim().indexOf(' ') >= 0) return col
                    else return `minmax(min-content, ${col})`
                }).join(' '),
            }
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        activeBreakpoint() {
            return useSetupStore().activeBreakpoint;
        },
    },
    methods: {
        resetDrawer() {
            this.$emit('cancel')

            // check if drawer section has been saved
            // if not, remove from state

            if (_.startsWith(this.drawer.section.id, 'new:')) {
                this.$nextTick(this.deleteSection)
            }

            this.drawer.loading = false
            this.drawer.saving = false
            this.drawer.tab = 'settings'
            this.drawer.section = undefined
        },
    },
    beforeCreate() {
        // this.$options.components.Area = require('../Area.vue').default;
        this.$options.components.Area = Area
    },
}
</script>

<style lang="sass" scoped>
.grid::v-deep .el-loading-mask
    background-color: hsl(0deg 0% calc(100% - var(--nesting-level) * 5%) / 0.5)

.grid
    border-radius: 0.25rem
    & > .page-area::v-deep
        & > .sticky-container > .area-title-bar
            // .handle
            //     pointer-events: none
            //     span.icon.sort
            //         display: none
            .delete-grid
                padding: 0 0.7rem
        // &:first-child > .sticky-container > .area-title-bar .handle
        //     pointer-events: initial
        //     span.icon.sort
        //         display: block

    // &:has( > .page-area > .sticky-container > .area-title-bar .delete-grid-button:hover),
    // &:has( > .page-area > .sticky-container > .area-title-bar .delete-grid-button:focus)
    //     outline-color: $--color-danger


.grid.preview
    padding: 0

.drawer-body::v-deep
    .el-tabs__content,
    .el-tab-pane,
    .tab-content
        display: flex
        flex-direction: column
        flex-grow: 1

.under-construction
    display: flex
    flex-grow: 1
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: rgba(0,0,0,0.2)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: rgba(0,0,0,0.3)
</style>
